import { Injectable } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import {
  Observable,
  debounceTime,
  switchMap,
  BehaviorSubject,
  finalize,
  catchError,
  of
} from 'rxjs';

@Injectable()
export class AutoCodeService {
  private _initialized = false;
  private searchChange$ = new BehaviorSubject<any>({});
  loadedParams = '';
  loading = false;
  formats: any[] = [];
  activeFormat: any | null = null;
  value: string = '';

  onChange: any = () => {};
  codeLoaded: any = () => {};

  constructor(private http: _HttpClient) {}

  reset() {
    this.loadedParams = '';
    this.loading = false;
    this.formats = [];
    this.activeFormat = null;
  }

  refreshSampleCode() {
    if (this.activeFormat && this.loadedParams) {
      this.selectFormat(this.activeFormat);
      let body = JSON.parse(this.loadedParams);
      body.formatId = this.activeFormat.id;
      this.http
        .post('api/RunningNumbers/AutoCode?_silent=true', body)
        .subscribe({
          next: res => {
            if (res) this.activeFormat.sampleCode = res;
          }
        });
    }
  }

  changeParams(queryParams: any) {
    this.initDebounceLoad();
    this.loading = true;
    this.searchChange$.next(queryParams);
  }

  private initDebounceLoad() {
    if (this._initialized) return;

    const fetchData$: Observable<any[]> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(500))
      .pipe(
        switchMap((queryParams: any) => {
          return this.http
            .get('api/RunningNumbers/Lookup', queryParams)
            .pipe(catchError(() => of([])))
            .pipe(
              finalize(() => {
                this.loadedParams = JSON.stringify(queryParams);
                this.loading = false;
              })
            );
        })
      );

    fetchData$.subscribe({
      next: res => {
        this.formats = [...res];

        if (this.formats.length) {
          let defaultFormat = null;
          if (this.activeFormat)
            defaultFormat = this.formats.find(
              o => o.id == this.activeFormat.id
            );
          if (
            !defaultFormat ||
            (this.activeFormat && this.activeFormat.forceAutoAssign)
          ) {
            defaultFormat = this.formats.find(o => o.isDefault);
          }

          if (defaultFormat) this.selectFormat(defaultFormat);
          if (res.length == 1) {
            const format = res[0];
            if (format.forceAutoAssign) {
              this.selectFormat(format);
            }
          }

          this.codeLoaded(this.activeFormat);
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });

    this._initialized = true;
  }

  selectFormat(format: any) {
    if (format) {
      this.activeFormat = format;
      this.value = `auto-${format.id}`;
      this.onChange(this.value);
    }
  }
}
